import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { bgCompanyRequestPath } from 'routes'
import { BottomActionsContainer } from './styled'
import { createBGCompanyRequest } from 'ducks/bgCompanyRequest'
import { validateField } from '../helper'
import { getVendors, getCompanies,getCustomers } from 'ducks/options'
import { 
  getListDocForExtend,
} from 'ducks/bgCompany'
import RequestForComponent from '../Shareds/RequestFor'
import BankGuaranteeInformation from '../Shareds/BankGuaranteeInformation'
import GeneralInformation from '../Shareds/GeneralInformation'
import ContactComponent from '../Shareds/Contact'
import AttachmentComponent from '../Shareds/Attachment'

const CreateBankGuaranteeCompanyRequest = (props) => {

  const { 
    detailDocForExtend,
    valueForm, 
    change,
    isDetail = false
  } = props

  const actionName = React.useRef('')
  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(() => {
    props.getVendors()
    props.getCompanies()
    props.getCustomers()
    props.getListDocForExtend()
  }, [])

  React.useEffect(()=>{
    if(valueForm.requestType=='extend'&&detailDocForExtend.id){
      change('companyCode',detailDocForExtend.companyCode)
      change('requestForType',detailDocForExtend.requestForType)
      change('requestForCode',detailDocForExtend.requestForCode)
      change('typeOfBond',detailDocForExtend.typeOfBond)
      if(detailDocForExtend.typeOfBondOther){
        change('typeOfBondOther',detailDocForExtend.typeOfBondOther)
      }
      change('amount',detailDocForExtend.amount)
      if(valueForm.isReferenceOriginal){
        change('referenceDocumentType',detailDocForExtend.referenceDocumentType)
        if(detailDocForExtend.referenceContractDate){
          change('referenceContractDate',detailDocForExtend.referenceContractDate)
        }
        if(detailDocForExtend.referenceContractNumber){
          change('referenceContractNumber',detailDocForExtend.referenceContractNumber)
        }
        if(detailDocForExtend.referencePurchaseOrderNumber){
          change('referencePurchaseOrderNumber',detailDocForExtend.referencePurchaseOrderNumber)
        }
        change('requesterUser',detailDocForExtend.requesterUser)
        change('projectManagerUser',detailDocForExtend.projectManagerUser)
        change('isContactValid',true)
        change('contacts',detailDocForExtend.contacts)
        //attachment
        if(detailDocForExtend.referenceDocumentType=='contract'){
          change('attachments',detailDocForExtend.attachments.filter(x=>x.documentCode=='BGC01'))
        }
        if(detailDocForExtend.referenceDocumentType=='poNumber'){
          change('attachments',detailDocForExtend.attachments.filter(x=>x.documentCode=='BGC02'))
        }
      }
    }
  },[detailDocForExtend])

  const onRequestTypeChange = (type) => {
    if(type=='new'){
      change('typeOfBond','')
      change('amount','')
      change('referenceDocumentType','')
      change('referenceContractDate','')
      change('referenceContractNumber','')
      change('extendBankGuaranteeId',null)
      change('referencePurchaseOrderNumber','')
      change('requesterUser','')
      change('projectManagerUser','')
      change('isContactValid',false)
      change('contacts',[])
      change('attachments',[])
    }
  }

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      setShowConfirm(true)
    })
  } 

  const confirmSubmit = () =>{
    setShowConfirm(false)
    props.createBGCompanyRequest(valueForm,actionName.current=='Submit',props.history)
  }
  
  return (
    <MainBodyContent 
      headerTitle='Request Bank Guarantee - Create'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'BG Company - Request New/Extend', link: true, onClick: () => props.history.push(bgCompanyRequestPath) },
              { key: 'BGCreate', content: 'Create', active: true }
            ]
          }
        />
      }
    >
      <div style={{height:'1rem'}}/>
      <RequestForComponent isEdit onRequestTypeChange={onRequestTypeChange}/>
      {valueForm.requestType?
        <React.Fragment>
          <BankGuaranteeInformation isEdit/>
          <GeneralInformation isEdit isDetail={isDetail}/>
          <ContactComponent isEdit/>
          <AttachmentComponent isCreate/>
          <div style={{height:'1rem'}}/>
          <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
            <BottomActionsContainer>
              <Button 
                content='Save' 
                icon='save' 
                labelPosition='right'
                style={{ marginRight: '5px' }}
                onClick={()=>{
                  actionName.current = 'Save'
                }}
              />
              <Button 
                content='Save & Submit' 
                color='blue' 
                icon='save' 
                labelPosition='right'
                style={{ marginRight: '5px' }}
                onClick={()=>{
                  actionName.current = 'Submit'
                }}
              />
            </BottomActionsContainer>
          </form>
        </React.Fragment>:null
      }
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => confirmSubmit()}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const valueForm = getFormValues('formBGCompanyRequest')(state) || {}

  return ({
    valueForm,
    initialValues: {
      requesterUser: username,
      attachments: [],
      contacts: [],
    },
    detailDocForExtend: state.bgCompany.detailDocForExtend.data
  })
}

const mapDispatchToProps = {
  createBGCompanyRequest,
  getVendors, 
  getCompanies,
  getListDocForExtend,
  getCustomers,
}

const validate = (values) => {
  let errors = validateField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGCompanyRequest',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CreateBankGuaranteeCompanyRequest)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
